import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function Serrvices() {
  const leftImgRef = useRef(null);
  const rightImgRef = useRef(null);

  // Detect when images are in view
  const leftInView = useInView(leftImgRef, { threshold: 0.1 });
  const rightInView = useInView(rightImgRef, { threshold: 0.1 });

  const leftToRightAnimation = {
    hidden: { x: -200, opacity: 0 }, // Start off-screen to the left
    visible: { x: 0, opacity: 1, transition: { duration: 2 } }, // Move to the original position
  };

  const rightToLeftAnimation = {
    hidden: { x: 200, opacity: 0 }, // Start off-screen to the right
    visible: { x: 0, opacity: 1, transition: { duration: 2 } }, // Move to the original position
  };

  return (
    <div
      style={{ backgroundImage: "url('/icons/service/BG.png')" }}
      className="flex overflow-hidden flex-col items-center h-[1393px] w-[1440px]"
    >
      <img src="/icons/service/3.png" className="mt-[24px]"></img>
      <div className="relative grid grid-cols-2 gap-[42px] mt-[116px] ">
        {/* Left Image */}
        <motion.img
          src="/icons/service/left.png"
          className=""
          ref={leftImgRef}
          variants={leftToRightAnimation}
          initial="hidden"
          animate={leftInView ? "visible" : "hidden"}
          alt="Left Image"
        />
        {/* Right Image */}
        <motion.img
          src="/icons/service/right.png"
          className="mt-[17px] ml-2"
          ref={rightImgRef}
          variants={rightToLeftAnimation}
          initial="hidden"
          animate={rightInView ? "visible" : "hidden"}
          alt="Right Image"
        />{" "}
      </div>
      <div className="px-[117px] ">
        <div className="grid grid-cols-2 gap-[60px] ">
          <div className=" flex flex-col">
            <div>
              <h2 className="font-bold text-[27px] text-[#000000]">
                <span className="font-montserrat font-bold text-[#E32D33] text-[32px]">
                  01 {"  "}
                </span>
                Field Marketing Solution
              </h2>

              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • In-store promotion and Demonstration
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Merchandising
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Sampling & demonstration
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Brand Activation Campaign
              </h3>
            </div>
            <div>
              <h2 className="font-bold text-[27px] text-[#000000]">
                <span className="font-montserrat font-bold text-[#E32D33] text-[32px]">
                  02 {"  "}
                </span>
                Trade Census and Audit
              </h2>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Track & gauge the effectiveness of on-ground
              </h3>
              <h3 className="indent-[50px]  font-normal text-xl text-[#434343]">
                trade marketing activities
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Retail Audit
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Trade Census
              </h3>
            </div>
            <div>
              <h2 className="font-bold text-[27px] text-[#000000]">
                <span className="font-montserrat font-bold text-[#E32D33] text-[32px]">
                  03 {"  "}
                </span>
                Total HR Outsourcing Solution
              </h2>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Payroll and Staffing Service
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Total HR Outsourcing Service
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Universal Production Process Outsourcing
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Field Force Management
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]">
                • Field Sales Support and Training
              </h3>
            </div>
          </div>
          <div className=" flex flex-col mt-1">
            <div>
              <h2 className="font-bold text-[27px] text-[#000000]">
                <span className="font-montserrat font-bold text-[#E32D33] text-[32px]">
                  04 {"  "}
                </span>
                Recruitment Solution
              </h2>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 6 }}>
                • Executive Search/ Headhunting Services
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 6 }}>
                • Recruitment Process Outsourcing
              </h3>

              <h3 className="indent-8 font-normal text-xl text-[#434343] margin-bottom" style={{ marginBottom: -3 }}>
                • Mass Recruitment Services
              </h3>
              <h3 className="indent-[49px] font-normal text-xl text-[#434343]">
                {/* (TrumViec) */}
              </h3>
            </div>
            <div className="mt-[14px]">
              <h2 className="font-bold text-[27px] text-[#000000]">
                <span className="font-montserrat font-bold text-[#E32D33] text-[32px]">
                  05 {"  "}
                </span>
                Consulting & Training Solution
              </h2>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 5 }}>
                • HR Consulting
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 5 }}>
                • Sales & Marketing Training Services
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 5 }}>
                • Leadership Training Services
              </h3>
            </div>
            <div className="mt-[14px]">
              <h2 className="font-bold text-[27px] text-[#000000]">
                <span className="font-montserrat font-bold text-[#E32D33] text-[32px]">
                  06 {"  "}
                </span>
                IT Outsourcing Solution
              </h2>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 6 }}>
                • IT Outsourcing Services
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 6 }}>
                • Application Development Services
              </h3>
              <h3 className="indent-8 font-normal text-xl text-[#434343]" style={{ marginBottom: 6 }}>
                • AI Development Services
              </h3>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-[60px] ">
          <div className=" flex flex-col"></div>
          <div className=" flex flex-col mt-1"></div>
        </div>
        <div className="grid grid-cols-2 gap-[60px] ">
          <div className=" flex flex-col"></div>
          <div className=" flex flex-col mt-1"></div>
        </div>
      </div>
    </div>
  );
}
